import { parse } from '@config/theme';
import { decodeAssetId } from '@lib/sanity/decode-asset-id';
import { blurImage, urlFor } from '@lib/sanity/url-for';
import Image from 'next/image';
import React, { FC } from 'react';
import { BlogItem } from '__generated__/sanity';
export const BlogHero: FC<BlogItem['fields']['hero']> = ({
  image
}) => {
  const {
    dimensions
  } = decodeAssetId(image.asset._ref);
  return <div className={container}>
      <Image src={urlFor(image).toString()} layout="responsive" blurDataURL={blurImage(image)} placeholder="blur" alt={image.alt} {...dimensions} />
    </div>;
};
const container = parse({
  width: '100%',
  mx: 'auto'
}, "cn0asuj");

require("./Hero.linaria.module.css!=!../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Hero.tsx");